import script from "./ComponenteDadosBasicos.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponenteDadosBasicos.vue?vue&type=script&setup=true&lang=js"

import "./ComponenteDadosBasicos.vue?vue&type=style&index=0&id=7978fa9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7978fa9e"]])

export default __exports__